type UpdateAgendaItemDataProps = {
    subject?: string;

    description?: string;

    location?: string;

    timeUpdate?: {
        start: string;
        end: string;
        isAllDay?: boolean;
    };

    attendees?: string[];
};

class UpdateAgendaItemData {
    subject?: string;

    description?: string;

    location?: string;

    timeUpdate?: {
        start: string;
        end: string;
        isAllDay?: boolean;
    };

    attendees?: string[];

    constructor({
        subject,
        description,
        location,
        timeUpdate,
        attendees,
    }: UpdateAgendaItemDataProps) {
        this.subject = subject;
        this.description = description;
        this.location = location;
        this.timeUpdate = timeUpdate;
        this.attendees = attendees;
    }
}

export default UpdateAgendaItemData;
